(() => {
  const imageCache = new Map();

  const framing = {
    "bonnie-clyde": {
      ps5: { scale: 1.04, x: 0, y: -0.01 },
      xbox: { scale: 1.02, x: 0, y: -0.015 },
      elite: { scale: 1.02, x: 0, y: -0.015 }
    },
    "the-chase": {
      ps5: { scale: 1.05, x: -0.015, y: -0.02 },
      xbox: { scale: 1.04, x: -0.015, y: -0.015 },
      elite: { scale: 1.04, x: -0.015, y: -0.015 }
    },
    oceanview: {
      ps5: { scale: 1.04, x: 0, y: -0.01 },
      xbox: { scale: 1.02, x: 0, y: -0.01 },
      elite: { scale: 1.02, x: 0, y: -0.01 }
    },
    "sunset-skyline": {
      ps5: { scale: 1, x: 0, y: 0 },
      xbox: { scale: 1, x: 0, y: 0 },
      elite: { scale: 1, x: 0, y: 0 }
    },
    "dual-silhouette": {
      ps5: { scale: 1.04, x: 0, y: -0.015 },
      xbox: { scale: 1.02, x: 0, y: -0.01 },
      elite: { scale: 1.02, x: 0, y: -0.01 }
    },
    "armed-confident": {
      ps5: { scale: 1.06, x: -0.025, y: -0.015 },
      xbox: { scale: 1.05, x: -0.02, y: -0.01 },
      elite: { scale: 1.05, x: -0.02, y: -0.01 }
    },
    "night-reflections": {
      ps5: { scale: 1, x: 0, y: 0 },
      xbox: { scale: 1, x: 0, y: 0 },
      elite: { scale: 1, x: 0, y: 0 }
    },
    "glitch-culture": {
      ps5: { scale: 1.02, x: 0, y: 0 },
      xbox: { scale: 1.02, x: 0, y: 0 },
      elite: { scale: 1.02, x: 0, y: 0 }
    }
  };

  function loadImage(url) {
    if (!imageCache.has(url)) {
      imageCache.set(url, new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.decoding = "async";
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = url;
      }));
    }
    return imageCache.get(url);
  }

  function initLab(lab) {
    if (!lab || lab.dataset.labInitialized === "true") return;
    lab.dataset.labInitialized = "true";
    document.body.classList.add("rush-lab-v2-active");

    const canvas = lab.querySelector("[data-lab-canvas]");
    const stage = lab.querySelector("[data-preview-stage]");
    const stageArt = lab.querySelector("[data-stage-art]");
    const modelButtons = [...lab.querySelectorAll("[data-lab-model]")];
    const viewButtons = [...lab.querySelectorAll("[data-lab-view]")];
    const designButtons = [...lab.querySelectorAll("[data-design-id]")];
    const filterButtons = [...lab.querySelectorAll("[data-design-filter]")];
    const designGrid = lab.querySelector("[data-design-grid]");
    const sortSelect = lab.querySelector("[data-design-sort]");
    const searchInput = lab.querySelector("[data-design-search]");
    const visibleCount = lab.querySelector("[data-visible-count]");
    const emptyState = lab.querySelector("[data-design-empty]");
    const summaryTitle = lab.querySelector("[data-summary-title]");
    const summaryModel = lab.querySelector("[data-summary-model]");
    const summaryPrice = lab.querySelector("[data-summary-price]");
    const modelFeatures = lab.querySelector("[data-model-features-output]");
    const presetButtons = [...lab.querySelectorAll("[data-lab-preset]")];
    const prototypeNote = lab.querySelector("[data-prototype-note]");
    const checkoutStatus = lab.querySelector("[data-checkout-status]");
    const continueButton = lab.querySelector("[data-lab-continue]");
    const continueDesktopLabel = continueButton?.querySelector(".rush-lab-v2__continue-desktop");
    const continueMobileLabel = continueButton?.querySelector(".rush-lab-v2__continue-mobile");
    const resetButton = lab.querySelector("[data-lab-reset]");
    const saveButton = lab.querySelector("[data-lab-save]");
    const saveLabel = lab.querySelector("[data-save-label]");
    const shareButton = lab.querySelector("[data-lab-share]");
    const downloadButton = lab.querySelector("[data-lab-download]");
    const expandButton = lab.querySelector("[data-lab-expand]");
    const previewModal = lab.querySelector("[data-preview-modal]");
    const modalArt = lab.querySelector("[data-modal-art]");
    const modalCanvas = lab.querySelector("[data-modal-canvas]");
    const modalTitle = lab.querySelector("[data-modal-title]");
    const modalModel = lab.querySelector("[data-modal-model]");
    const modalClose = lab.querySelector("[data-modal-close]");
    const modalViewButtons = [...lab.querySelectorAll("[data-modal-view]")];

    if (!canvas || !stage || !modelButtons.length || !viewButtons.length || !designButtons.length) return;

    const context = canvas.getContext("2d");
    const buffer = document.createElement("canvas");
    buffer.width = canvas.width;
    buffer.height = canvas.height;
    const bufferContext = buffer.getContext("2d");
    const modalContext = modalCanvas.getContext("2d");

    let selectedModel = modelButtons.find((button) => button.classList.contains("is-selected")) || modelButtons[0];
    let selectedView = viewButtons.find((button) => button.classList.contains("is-selected")) || viewButtons[0];
    let selectedDesign = designButtons.find((button) => button.classList.contains("is-selected")) || designButtons[0];
    let activeFilter = "all";
    let renderId = 0;
    let isAddingToCart = false;
    let noteTimer;
    const cartAddUrl = lab.dataset.cartAddUrl || "/cart/add.js";
    const cartUrl = lab.dataset.cartUrl || "/cart";
    const savedBuildKey = "rush-custom-lab-v2-build";
    const favoriteDesignsKey = "rush-custom-lab-v2-favorite-designs";
    const recentDesignsKey = "rush-custom-lab-v2-recent-designs";
    const originalOrder = new Map(designButtons.map((button, index) => [button, index]));
    const latestDragonBallIds = new Set([
      "db-vegeta-original-artwork",
      "db-goku-original-artwork",
      "db-gohan-original-artwork",
      "db-future-trunks-original-artwork",
      "db-piccolo-original-artwork",
      "db-frieza-original-artwork",
      "db-perfect-cell-original-artwork",
      "db-majin-buu-original-artwork",
      "db-broly-original-artwork",
      "db-shenron-original-artwork"
    ]);
    const defaultBuild = {
      model: selectedModel.dataset.labModel,
      view: selectedView.dataset.labView,
      design: selectedDesign.dataset.designId
    };

    const urlParams = new URLSearchParams(window.location.search);
    selectedModel = modelButtons.find((button) => button.dataset.labModel === urlParams.get("controller")) || selectedModel;
    selectedView = viewButtons.find((button) => button.dataset.labView === urlParams.get("side")) || selectedView;
    selectedDesign = designButtons.find((button) => button.dataset.designId === urlParams.get("design")) || selectedDesign;

    function readStoredIds(key) {
      try {
        const value = JSON.parse(window.localStorage.getItem(key) || "[]");
        return Array.isArray(value) ? value.filter((id) => typeof id === "string") : [];
      } catch (error) {
        return [];
      }
    }

    function writeStoredIds(key, ids) {
      try {
        window.localStorage.setItem(key, JSON.stringify(ids.slice(0, 24)));
      } catch (error) {
        // Local storage can be unavailable in private browsing; the lab still works.
      }
    }

    let favoriteIds = new Set(readStoredIds(favoriteDesignsKey));
    let recentIds = readStoredIds(recentDesignsKey);

    designButtons.forEach((button) => {
      button.style.setProperty("--design-accent", button.dataset.designAccent || "#ff302c");
      button.style.setProperty("--design-accent-2", button.dataset.designAccentSecondary || button.dataset.designAccent || "#ff302c");
    });

    function getBuildState() {
      return {
        model: selectedModel.dataset.labModel,
        view: selectedView.dataset.labView,
        design: selectedDesign.dataset.designId
      };
    }

    function getPurchaseOption() {
      const coverage = selectedView.dataset.labView;
      return {
        variantId: Number(selectedModel.dataset[`${coverage}VariantId`] || 0),
        price: selectedModel.dataset[`${coverage}Price`] || selectedModel.dataset.modelPrice,
        available: selectedModel.dataset[`${coverage}Available`] === "true",
        coverageLabel: coverage === "back" ? "Front + Back" : "Front only"
      };
    }

    function updateDesignThumbnails() {
      designButtons.forEach((button) => {
        const image = button.querySelector("img");
        const artwork = button.dataset.designArt;
        if (image && artwork && image.src !== artwork) image.src = artwork;
      });
    }

    function syncControlStates() {
      modelButtons.forEach((item) => {
        const selected = item === selectedModel;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-pressed", String(selected));
      });
      viewButtons.forEach((item) => {
        const selected = item === selectedView;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-pressed", String(selected));
      });
      designButtons.forEach((item) => {
        const selected = item === selectedDesign;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-pressed", String(selected));
      });
      modalViewButtons.forEach((item) => {
        const selected = item.dataset.modalView === selectedView.dataset.labView;
        item.classList.toggle("is-selected", selected);
        item.setAttribute("aria-pressed", String(selected));
      });
    }

    function updateFavoriteStates() {
      designButtons.forEach((design) => {
        const favorite = design.querySelector("[data-design-favorite]");
        const isFavorite = favoriteIds.has(design.dataset.designId);
        if (!favorite) return;
        favorite.classList.toggle("is-favorite", isFavorite);
        favorite.setAttribute("aria-pressed", String(isFavorite));
        favorite.setAttribute("aria-label", `${isFavorite ? "Remove" : "Save"} ${design.dataset.designTitle}`);
        favorite.innerHTML = `<span class="material-symbols-outlined" aria-hidden="true">${isFavorite ? "favorite" : "favorite_border"}</span>`;
      });
      const savedCount = lab.querySelector('[data-filter-count="saved"]');
      const recentCount = lab.querySelector('[data-filter-count="recent"]');
      if (savedCount) savedCount.textContent = String(favoriteIds.size);
      if (recentCount) recentCount.textContent = String(recentIds.length);
    }

    function decorateDesignCards() {
      designButtons.forEach((design) => {
        if (design.querySelector("[data-design-favorite]")) return;
        const favorite = document.createElement("span");
        favorite.className = "rush-lab-v2__design-favorite";
        favorite.dataset.designFavorite = "true";
        favorite.setAttribute("role", "button");
        favorite.setAttribute("tabindex", "0");
        favorite.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleFavorite(design);
        });
        favorite.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          event.stopPropagation();
          toggleFavorite(design);
        });
        design.insertBefore(favorite, design.firstChild);
      });
      updateFavoriteStates();
    }

    function toggleFavorite(design) {
      const id = design.dataset.designId;
      if (favoriteIds.has(id)) {
        favoriteIds.delete(id);
        showMessage(`${design.dataset.designTitle} removed from saved designs.`);
      } else {
        favoriteIds.add(id);
        showMessage(`${design.dataset.designTitle} saved to this device.`);
      }
      writeStoredIds(favoriteDesignsKey, [...favoriteIds]);
      updateFavoriteStates();
      if (activeFilter === "saved") filterDesigns();
    }

    function rememberRecent(design) {
      const id = design.dataset.designId;
      recentIds = [id, ...recentIds.filter((item) => item !== id)].slice(0, 24);
      writeStoredIds(recentDesignsKey, recentIds);
      updateFavoriteStates();
    }

    function updateVisualTheme() {
      const primary = selectedDesign.dataset.designAccent || "#ff302c";
      const secondary = selectedDesign.dataset.designAccentSecondary || primary;
      const image = `url("${selectedDesign.dataset.designArt}")`;
      lab.style.setProperty("--lab-design-1", primary);
      lab.style.setProperty("--lab-design-2", secondary);
      stageArt.style.backgroundImage = image;
      modalArt.style.backgroundImage = image;
    }

    function updateModalPreview() {
      if (previewModal.hidden) return;
      modalContext.clearRect(0, 0, modalCanvas.width, modalCanvas.height);
      modalContext.drawImage(canvas, 0, 0, modalCanvas.width, modalCanvas.height);
      modalTitle.textContent = selectedDesign.dataset.designTitle;
      modalModel.textContent = `${selectedModel.dataset.modelLabel} · ${selectedView.dataset.labView === "back" ? "Back" : "Front"} view`;
    }

    function showMessage(message) {
      window.clearTimeout(noteTimer);
      prototypeNote.textContent = message;
      prototypeNote.hidden = false;
      noteTimer = window.setTimeout(() => {
        prototypeNote.hidden = true;
      }, 4200);
    }

    function readSavedBuild() {
      try {
        return JSON.parse(window.localStorage.getItem(savedBuildKey));
      } catch (error) {
        return null;
      }
    }

    function updateSaveButton() {
      const saved = readSavedBuild();
      const current = getBuildState();
      const isSaved = saved && saved.model === current.model && saved.view === current.view && saved.design === current.design;
      saveButton.classList.toggle("is-saved", Boolean(isSaved));
      saveButton.setAttribute("aria-pressed", String(Boolean(isSaved)));
      saveLabel.textContent = isSaved ? "Saved" : "Save";
    }

    function getPreviewAssets() {
      const view = selectedView.dataset.labView;
      return {
        mask: selectedModel.dataset[`${view}Mask`],
        depth: selectedModel.dataset[`${view}Depth`],
        overlay: selectedModel.dataset[`${view}Overlay`]
      };
    }

    async function renderPreview() {
      const currentRender = ++renderId;
      stage.classList.add("is-loading");

      try {
        const assets = getPreviewAssets();
        const [art, mask, depth, overlay] = await Promise.all([
          loadImage(selectedDesign.dataset.designArt),
          loadImage(assets.mask),
          loadImage(assets.depth),
          loadImage(assets.overlay)
        ]);
        if (currentRender !== renderId) return;

        const width = canvas.width;
        const height = canvas.height;
        const modelKey = selectedModel.dataset.labModel;
        const frame = framing[selectedDesign.dataset.designId]?.[modelKey] || { scale: 1, x: 0, y: 0 };
        const coverScale = Math.max(width / art.naturalWidth, height / art.naturalHeight) * frame.scale;
        const drawWidth = art.naturalWidth * coverScale;
        const drawHeight = art.naturalHeight * coverScale;
        const drawX = (width - drawWidth) / 2 + frame.x * width;
        const drawY = (height - drawHeight) / 2 + frame.y * height;

        bufferContext.clearRect(0, 0, width, height);
        bufferContext.globalCompositeOperation = "source-over";
        bufferContext.drawImage(art, drawX, drawY, drawWidth, drawHeight);
        bufferContext.globalCompositeOperation = "destination-in";
        bufferContext.drawImage(mask, 0, 0, width, height);

        bufferContext.globalCompositeOperation = "source-atop";
        const shellShade = bufferContext.createLinearGradient(0, 0, 0, height);
        shellShade.addColorStop(0, "rgba(0, 0, 0, 0.18)");
        shellShade.addColorStop(0.16, "rgba(255, 255, 255, 0.045)");
        shellShade.addColorStop(0.52, "rgba(255, 255, 255, 0)");
        shellShade.addColorStop(1, "rgba(0, 0, 0, 0.2)");
        bufferContext.fillStyle = shellShade;
        bufferContext.fillRect(0, 0, width, height);

        const shellHighlight = bufferContext.createRadialGradient(width * 0.42, height * 0.12, 0, width * 0.42, height * 0.22, width * 0.55);
        shellHighlight.addColorStop(0, "rgba(255, 255, 255, 0.09)");
        shellHighlight.addColorStop(0.42, "rgba(255, 255, 255, 0.02)");
        shellHighlight.addColorStop(1, "rgba(255, 255, 255, 0)");
        bufferContext.fillStyle = shellHighlight;
        bufferContext.fillRect(0, 0, width, height);
        bufferContext.drawImage(depth, 0, 0, width, height);
        bufferContext.globalCompositeOperation = "source-over";

        context.clearRect(0, 0, width, height);
        context.drawImage(buffer, 0, 0);
        context.drawImage(overlay, 0, 0, width, height);
        const previewSide = selectedView.dataset.labView === "back" ? "Back" : "Front";
        canvas.setAttribute("aria-label", `${previewSide} view of ${selectedModel.dataset.modelLabel} with ${selectedDesign.dataset.designTitle} design`);
        updateModalPreview();
      } catch (error) {
        console.error("Rush Custom Lab preview failed to load.", error);
      } finally {
        if (currentRender === renderId) stage.classList.remove("is-loading");
      }
    }

    async function renderDesignThumbnails() {
      const model = modelButtons.find((button) => button.dataset.labModel === "ps5") || modelButtons[0];
      const maskUrl = model.dataset.frontMask;
      const depthUrl = model.dataset.frontDepth;
      const overlayUrl = model.dataset.frontOverlay;
      if (!maskUrl || !depthUrl || !overlayUrl) return;
      const [mask, depth, overlay] = await Promise.all([loadImage(maskUrl), loadImage(depthUrl), loadImage(overlayUrl)]);
      const thumb = document.createElement("canvas");
      thumb.width = 440;
      thumb.height = 330;
      const thumbContext = thumb.getContext("2d");
      for (const design of designButtons) {
        const image = design.querySelector("img");
        const artUrl = design.dataset.designArt;
        if (!image || !artUrl || image.dataset.controllerThumbnail === "true") continue;
        try {
          const art = await loadImage(artUrl);
          const scale = Math.max(thumb.width / art.naturalWidth, thumb.height / art.naturalHeight);
          const width = art.naturalWidth * scale;
          const height = art.naturalHeight * scale;
          thumbContext.clearRect(0, 0, thumb.width, thumb.height);
          thumbContext.globalCompositeOperation = "source-over";
          thumbContext.drawImage(art, (thumb.width - width) / 2, (thumb.height - height) / 2, width, height);
          thumbContext.globalCompositeOperation = "destination-in";
          thumbContext.drawImage(mask, 0, 0, thumb.width, thumb.height);
          thumbContext.globalCompositeOperation = "source-atop";
          thumbContext.drawImage(depth, 0, 0, thumb.width, thumb.height);
          thumbContext.globalCompositeOperation = "source-over";
          thumbContext.drawImage(overlay, 0, 0, thumb.width, thumb.height);
          image.src = thumb.toDataURL("image/png");
          image.dataset.controllerThumbnail = "true";
        } catch (error) {
          console.warn("Rush Custom Lab thumbnail failed to load.", error);
        }
      }
    }

    function updateSummary() {
      const purchase = getPurchaseOption();
      summaryTitle.textContent = selectedDesign.dataset.designTitle;
      summaryModel.textContent = `${selectedModel.dataset.modelLabel} · ${purchase.coverageLabel}`;
      summaryPrice.textContent = purchase.price;
      modelFeatures.textContent = selectedModel.dataset.modelFeatures;
      continueButton.disabled = !purchase.variantId || !purchase.available || isAddingToCart;
      if (checkoutStatus) {
        checkoutStatus.textContent = purchase.variantId
          ? (purchase.available ? "Secure Shopify cart · Your design and coverage are included with the order" : "This configuration is currently sold out.")
          : "Purchase setup is required for this controller model.";
        checkoutStatus.classList.toggle("has-error", !purchase.variantId || !purchase.available);
      }
      updateVisualTheme();
      updateSaveButton();
    }

    function selectModel(button) {
      selectedModel = button;
      syncControlStates();
      updateDesignThumbnails();
      updateSummary();
      renderPreview();
    }

    function selectView(button) {
      selectedView = button;
      stage.classList.remove("is-flipping");
      void stage.offsetWidth;
      stage.classList.add("is-flipping");
      window.setTimeout(() => stage.classList.remove("is-flipping"), 380);
      syncControlStates();
      updateSummary();
      renderPreview();
    }

    function selectDesign(button) {
      selectedDesign = button;
      rememberRecent(button);
      syncControlStates();
      updateSummary();
      renderPreview();
    }

    function filterDesigns() {
      const term = searchInput.value.trim().toLocaleLowerCase();
      const normalizedTerm = term.replace(/[^a-z0-9]/g, "");
      let count = 0;

      designButtons.forEach((button) => {
        const haystack = `${button.dataset.designTitle} ${button.dataset.designCategory} ${button.textContent}`.toLocaleLowerCase();
        const normalizedHaystack = haystack.replace(/[^a-z0-9]/g, "");
        const matchesSearch = !term || haystack.includes(term) || normalizedHaystack.includes(normalizedTerm);
        const themeMap = {
          "bonnie-clyde": ["vice-city", "crime-characters", "neon-city"],
          "the-chase": ["vice-city", "crime-characters", "neon-city"],
          oceanview: ["vice-city", "neon-city"],
          "sunset-skyline": ["vice-city", "neon-city"],
          "dual-silhouette": ["crime-characters", "neon-city"],
          "armed-confident": ["crime-characters", "graphic-glitch"],
          "night-reflections": ["vice-city", "neon-city"],
          "glitch-culture": ["graphic-glitch"],
          "oni-flame-smoke-ukiyoe": ["ukiyoe-oni", "graphic-glitch"],
          "symmetrical-oni-flames": ["ukiyoe-oni", "graphic-glitch"],
          "ukiyoe-oni-checkerboard": ["ukiyoe-oni", "graphic-glitch"],
          "ukiyoe-oni-sacred-patterns": ["ukiyoe-oni", "graphic-glitch"],
          "asanoha-checkerboard-oni": ["ukiyoe-oni", "graphic-glitch"]
        };
        const themes = themeMap[button.dataset.designId] || button.dataset.designCategory.split(" ");
        const matchesFilter = activeFilter === "all"
          || (activeFilter === "saved" && favoriteIds.has(button.dataset.designId))
          || (activeFilter === "recent" && recentIds.includes(button.dataset.designId))
          || themes.includes(activeFilter);
        const visible = matchesSearch && matchesFilter;
        button.hidden = !visible;
        if (visible) count += 1;
      });

      visibleCount.textContent = String(count);
      emptyState.hidden = count !== 0;
    }

    function sortDesigns() {
      const direction = sortSelect.value;
      const dragonBallMode = activeFilter === "dragon-ball" || ["dragonball", "dragonballartwork"].includes(searchInput.value.trim().toLocaleLowerCase().replace(/[^a-z0-9]/g, ""));
      const sorted = [...designButtons].sort((a, b) => {
        if (direction === "recommended" && dragonBallMode) {
          const aIsLatest = latestDragonBallIds.has(a.dataset.designId);
          const bIsLatest = latestDragonBallIds.has(b.dataset.designId);
          if (aIsLatest !== bIsLatest) return aIsLatest ? -1 : 1;
        }
        if (direction === "az") return a.dataset.designTitle.localeCompare(b.dataset.designTitle);
        if (direction === "za") return b.dataset.designTitle.localeCompare(a.dataset.designTitle);
        return originalOrder.get(a) - originalOrder.get(b);
      });
      sorted.forEach((button) => designGrid.appendChild(button));
      filterDesigns();
    }

    function resetBuild() {
      selectedModel = modelButtons.find((button) => button.dataset.labModel === defaultBuild.model) || modelButtons[0];
      selectedView = viewButtons.find((button) => button.dataset.labView === defaultBuild.view) || viewButtons[0];
      selectedDesign = designButtons.find((button) => button.dataset.designId === defaultBuild.design) || designButtons[0];
      searchInput.value = "";
      activeFilter = "all";
      sortSelect.value = "recommended";
      filterButtons.forEach((item) => item.classList.toggle("is-active", item.dataset.designFilter === "all"));
      syncControlStates();
      sortDesigns();
      updateDesignThumbnails();
      updateSummary();
      renderPreview();
      showMessage("Build reset to the recommended starting point.");
    }

    function saveBuild() {
      try {
        window.localStorage.setItem(savedBuildKey, JSON.stringify(getBuildState()));
        updateSaveButton();
        showMessage("Build saved on this device.");
      } catch (error) {
        showMessage("This browser could not save the build.");
      }
    }

    async function copyBuildLink() {
      const url = new URL(window.location.href);
      const state = getBuildState();
      url.searchParams.set("controller", state.model);
      url.searchParams.set("design", state.design);
      url.searchParams.set("side", state.view);

      try {
        await navigator.clipboard.writeText(url.toString());
        window.history.replaceState({}, "", url);
        showMessage("Build link copied. Anyone opening it will see this configuration.");
      } catch (error) {
        showMessage("Copying is unavailable in this browser.");
      }
    }

    function downloadPreview() {
      try {
        const link = document.createElement("a");
        link.download = `${selectedDesign.dataset.designId}-${selectedModel.dataset.labModel}-${selectedView.dataset.labView}.png`;
        link.href = canvas.toDataURL("image/png");
        link.click();
        showMessage("Preview downloaded as a PNG.");
      } catch (error) {
        showMessage("The preview could not be downloaded in this browser.");
      }
    }

    function openPreviewModal() {
      previewModal.hidden = false;
      document.body.classList.add("rush-lab-modal-open");
      syncControlStates();
      updateModalPreview();
      modalClose.focus();
    }

    function closePreviewModal() {
      previewModal.hidden = true;
      document.body.classList.remove("rush-lab-modal-open");
      expandButton.focus();
    }

    modelButtons.forEach((button) => button.addEventListener("click", () => selectModel(button)));
    viewButtons.forEach((button) => button.addEventListener("click", () => selectView(button)));
    designButtons.forEach((button) => button.addEventListener("click", () => selectDesign(button)));
    presetButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const model = modelButtons.find((item) => item.dataset.labModel === button.dataset.presetModel);
        const design = designButtons.find((item) => item.dataset.designId === button.dataset.presetDesign);
        const front = viewButtons.find((item) => item.dataset.labView === "front");
        if (!model || !design || !front) return;
        selectedModel = model;
        selectedDesign = design;
        selectedView = front;
        rememberRecent(design);
        syncControlStates();
        updateDesignThumbnails();
        updateSummary();
        renderPreview();
        showMessage(`${design.dataset.designTitle} quick build applied.`);
      });
    });

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeFilter = button.dataset.designFilter;
        filterButtons.forEach((item) => item.classList.toggle("is-active", item === button));
        sortDesigns();
      });
    });

    searchInput.addEventListener("input", sortDesigns);
    sortSelect.addEventListener("change", sortDesigns);
    resetButton.addEventListener("click", resetBuild);
    saveButton.addEventListener("click", saveBuild);
    shareButton.addEventListener("click", copyBuildLink);
    downloadButton?.addEventListener("click", downloadPreview);
    expandButton.addEventListener("click", openPreviewModal);
    modalClose.addEventListener("click", closePreviewModal);
    modalViewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const matchingView = viewButtons.find((item) => item.dataset.labView === button.dataset.modalView);
        if (matchingView) selectView(matchingView);
      });
    });
    previewModal.addEventListener("click", (event) => {
      if (event.target === previewModal) closePreviewModal();
    });

    stage.addEventListener("pointermove", (event) => {
      if (!window.matchMedia("(pointer: fine)").matches) return;
      const bounds = stage.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      canvas.style.setProperty("--lab-tilt-x", `${-y * 3.2}deg`);
      canvas.style.setProperty("--lab-tilt-y", `${x * 4.2}deg`);
    });
    stage.addEventListener("pointerleave", () => {
      canvas.style.setProperty("--lab-tilt-x", "0deg");
      canvas.style.setProperty("--lab-tilt-y", "0deg");
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !previewModal.hidden) {
        closePreviewModal();
        return;
      }
      if (event.key === "/" && document.activeElement !== searchInput && !/input|textarea/i.test(document.activeElement?.tagName || "")) {
        event.preventDefault();
        searchInput.focus();
      }
    });

    continueButton.addEventListener("click", async () => {
      if (isAddingToCart) return;
      const purchase = getPurchaseOption();
      if (!purchase.variantId || !purchase.available) {
        showMessage(purchase.variantId ? "This configuration is currently sold out." : "This controller is not connected to a purchase product yet.");
        updateSummary();
        return;
      }

      isAddingToCart = true;
      continueButton.disabled = true;
      if (continueDesktopLabel) continueDesktopLabel.textContent = "Adding…";
      if (continueMobileLabel) continueMobileLabel.textContent = "Adding…";
      if (checkoutStatus) {
        checkoutStatus.textContent = "Adding your Custom Lab controller to the secure Shopify cart…";
        checkoutStatus.classList.remove("has-error");
      }

      try {
        const selectedCardImage = selectedDesign.querySelector("img")?.dataset[`card${selectedModel.dataset.labModel.charAt(0).toUpperCase()}${selectedModel.dataset.labModel.slice(1)}`] || selectedDesign.dataset.designArt;
        const response = await fetch(cartAddUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [{
              id: purchase.variantId,
              quantity: 1,
              properties: {
                "Custom Lab build": `${selectedDesign.dataset.designTitle} — ${selectedModel.dataset.modelLabel}`,
                "Custom Lab design": selectedDesign.dataset.designTitle,
                "Design ID": selectedDesign.dataset.designId,
                "Controller": selectedModel.dataset.modelLabel,
                "Print coverage": purchase.coverageLabel,
                "_Custom Lab image": selectedCardImage
              }
            }]
          })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || "This controller could not be added to cart.");
        }
        window.location.assign(cartUrl);
      } catch (error) {
        isAddingToCart = false;
        if (continueDesktopLabel) continueDesktopLabel.textContent = "Add to cart";
        if (continueMobileLabel) continueMobileLabel.textContent = "Add";
        if (checkoutStatus) {
          checkoutStatus.textContent = error.message || "The controller could not be added. Please try again.";
          checkoutStatus.classList.add("has-error");
        }
        showMessage(error.message || "The controller could not be added. Please try again.");
        updateSummary();
      }
    });

    syncControlStates();
    decorateDesignCards();
    updateDesignThumbnails();
    // Set the initial count from the full catalog; it should never rely on a placeholder value.
    filterDesigns();
    const initialAssets = getPreviewAssets();
    [initialAssets.overlay, initialAssets.mask, initialAssets.depth, selectedDesign.dataset.designArt].forEach(loadImage);
    updateSummary();
    renderPreview();
    // Keep the selector cards visually unified: show each design artwork
    // rather than mixing controller mockups with flat artwork thumbnails.
    designButtons.forEach((design) => {
      const image = design.querySelector("img");
      const artUrl = design.dataset.designArt;
      if (image && artUrl) image.src = artUrl;
    });
  }

  function initAll() {
    document.querySelectorAll("[data-rush-lab-v2]").forEach(initLab);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
